const PRIVILEGED_ROLES = new Set(['admin', 'super_admin', 'org_admin'])

/** Decode JWT payload (no signature verify — client-side viability check only). */
export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null
  const part = token.split('.')[1]
  if (!part) return null
  try {
    const padded = part + '='.repeat((4 - (part.length % 4)) % 4)
    const json = atob(padded.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(json)
  } catch {
    return null
  }
}

/** False when token is expired or lacks permissions (legacy sessions before RBAC was embedded). */
export function isSessionTokenViable(token) {
  const payload = decodeJwtPayload(token)
  if (!payload) return false
  if (payload.exp && payload.exp * 1000 <= Date.now()) return false
  const role = String(payload.role || '').toLowerCase()
  if (PRIVILEGED_ROLES.has(role)) return true
  if (typeof payload.sub === 'string' && payload.sub.toLowerCase() === 'admin') return true
  const perms = payload.permissions
  return Array.isArray(perms) && perms.length > 0
}
